module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_vm._v("Copyright © Tomb Raider Marathon 2017 " + _vm._s(_vm.getCopyrightDate))]), _vm._v(" "), _c('p', [_vm._v("We are in no way associated with Square Enix or Crystal Dynamics, we're a non-profit fan-based charity gaming marathon that aims to have fun whilst raising money for charity.")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc7dc86e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/FooterView.vue
// module id = 237
// module chunks = 1